import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { SLICE_NAMESPACE } from '../constants';
import { IBannersState } from '../types';

export const fetchAllPromotions = createAppAsyncThunk(`${SLICE_NAMESPACE}/fetchAllPromotions`, async () =>
  apiService.promotions.getPromotionSummaryList(),
);

export const fetchAllPromotionsReducer: TSliceExtraReducer<IBannersState> = builder =>
  builder
    .addCase(fetchAllPromotions.pending, state => {
      state.form.promotions.isLoading = true;
    })
    .addCase(fetchAllPromotions.rejected, state => {
      state.form.promotions.isLoading = false;
      state.form.promotions.options = [];
    })
    .addCase(fetchAllPromotions.fulfilled, (state, action) => {
      state.form.promotions.options = action.payload;
      state.form.promotions.isLoading = false;
    });
